/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Waiting from '../waiting';
import TypewriterText from './typewriter_text';
import AiBadge from './ai_badge';
import GuessesRemaining from './guesses_remaining';

export default class YakAiMessage extends React.Component {
  static propTypes = {
    message: PropTypes.object.isRequired,
    isLast: PropTypes.bool.isRequired,
    isChatSessionComplete: PropTypes.bool,
    isLoading: PropTypes.bool,
    onTypewriterComplete: PropTypes.func
  };

  state = {
    typewriterDone: false
  };

  _onTypewriterComplete = () => {
    this.setState({ typewriterDone: true });
    const { onTypewriterComplete } = this.props;
    onTypewriterComplete && onTypewriterComplete();
  };

  render() {
    const { message, isLast, isChatSessionComplete, isLoading } = this.props;

    let badgeStatus = 'default';
    // Only show success/failure badge on the LAST AI message when session is complete
    if (isChatSessionComplete && isLast) {
      badgeStatus = message.get('accuracy') > 74 ? 'correct' : 'incorrect';
    }

    const isLastMessageForThisSession = isLast && isChatSessionComplete;
    const shouldShowGuessesRemaining = this.state.typewriterDone && !isLastMessageForThisSession;

    return (
      <li className='message-item'>
        <AiBadge status={badgeStatus} />
        <div style={{ marginLeft: 18 }}>
          {!message.get('aiResponseMessage') && isLoading && isLast &&
            <Waiting />
          }
          {!!message.get('aiResponseMessage') &&
            <TypewriterText text={message.get('aiResponseMessage')} onComplete={this._onTypewriterComplete} />
          }
          {
            shouldShowGuessesRemaining &&
            <GuessesRemaining hintsRemaining={message.get('guessesRemaining')} />
          }
        </div>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/tack_ai_chat/yak_ai_message.jsx